import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcTableBody } from '@one/react';

export type PocTableBodyProps = ComponentPropsWithoutRef<typeof OwcTableBody>;

export const PocTableBody = forwardRef<ElementRef<typeof OwcTableBody>, PocTableBodyProps>((props, ref) => (
    <OwcTableBody ref={ref} {...props} />
));

PocTableBody.displayName = 'PocTableBody';
